import { render, staticRenderFns } from "./GatVesselSelect.vue?vue&type=template&id=8baf001c&scoped=true&"
import script from "./GatVesselSelect.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GatVesselSelect.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./GatVesselSelect.vue?vue&type=style&index=0&id=8baf001c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8baf001c",
  null
  
)

export default component.exports